export default __webpack_public_path__ + "static/media/IMG_20230719_125932 - Kritika Agrawal.59d80370.jpg";